import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { initializeDatabase } from "./db/database";
import "./styles.css";

async function bootstrap() {
  await initializeDatabase();
  ReactDOM.createRoot(document.getElementById("root")!).render(<React.StrictMode><App /></React.StrictMode>);
  if ("serviceWorker" in navigator && import.meta.env.PROD) {
    window.addEventListener("load", () => navigator.serviceWorker.register("./sw.js").catch(() => undefined));
  }
}

bootstrap().catch((error) => {
  document.getElementById("root")!.innerHTML = `<main style="padding:32px;font-family:system-ui"><h1>Não foi possível iniciar o aplicativo</h1><p>${error instanceof Error ? error.message : "Erro inesperado."}</p></main>`;
});
